import React, { useEffect, useState } from 'react';
import { Typography, Link } from '@mui/material';
import {
    Avatar,
    Box,
    Card
} from '@mui/material';

import { useAuth0 } from '@auth0/auth0-react';



const styles = {
    mountFadeIn: {
        opacity: 1,
        transition: 'opacity 0.5s'
    },
    mountFadeOut: {
        opacity: 0,
        transition: 'opacity 0.5s'
    }
}

export default function NotFoundView() {

    const { logout } = useAuth0()
    const KonsolLogout = () => {
    logout({ logoutParams: {returnTo: process.env.REACT_APP_AUTH0_LOGOUT_URL}})
}


    // KONSOL BASE PROPS


    const [onPageLoad, setOnPageLoad] = useState(false)

    useEffect(() => {
        setOnPageLoad(true)
    }, [])

    useEffect(()=>{
    },[onPageLoad])
    

    return (
        <React.Fragment>
            <Box
                height={'100vh'}
                width={'100%'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
            >
                <Card
                    sx={{
                        background: 'rgba(48, 89, 69, 0.2)',
                        borderRadius: '16px',
                        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.5)',
                        backdropFilter: 'blur(4.5px)',
                        transitionProperty: 'box-shadow',
                        transitionDuration: '1s',
                        width: 650,
                        height: 800
                    }}>
                    <Box 
                        display={'flex'}
                        height={'100%'}
                        flexDirection={'column'}
                    >
                        <Box 
                            display={'flex'}
                            justifyContent={'center'}
                            padding={'30px'}
                        />
                        <Box
                            display={'flex'}
                            justifyContent={'center'}
                            width={'100%'}
                            padding={'20px 0px'}
                        >
                            <img src="/logo/konsol-white.svg" className="App-logo" alt="logo" width="300px"/>
                        </Box>
                        <Box 
                            display={'flex'} 
                            justifyContent={'center'} 
                            width={'100%'} 
                            height={'100%'}
                        >
                            <Box
                                alignSelf={'center'}
                                display={'flex'}
                                justifyContent={'center'}
                                width={'90%'}
                          
                                
                            >
                                
                                <Box style={{color:'white'}}>
                                        <Typography align='left' variant="h4">
                                            Something went wrong.
                                        </Typography>
                                    <br/>
                                        Please check you are logging into the correct production.
                                    <br/>
                                    <br/>
                                        If you continue to see this error, click the Help button, or
                                    <br/>
                                    <br/>
                                        contact <Link 
                                        href="mailto:support@rebelfleet.co.nz" 
                                        target="_blank" 
                                        style={{color:'white'}}>
                                            support@rebelfleet.co.nz
                                        </Link> for assistance.
                                </Box>
                                        
                            </Box>
                        </Box>
                    </Box>
                </Card>
            </Box>
        </React.Fragment>
    )
}
